import type {ClipboardState} from './types'

export const emptyClipboard: ClipboardState = {type: 'empty'} as const
